import { Component, OnInit, TemplateRef, EventEmitter, Output, Input, OnChanges, ViewChild, OnDestroy } from '@angular/core';
import { InstitutionData } from '../Models/InstitutionData';
import { PHBHPFeaturePackageInsitutionManagementService } from '../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserData } from '../Models/UserData';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-trialinstitution',
  templateUrl: './ph-bhp-trialinstitution.component.html',
  styleUrls: ['./ph-bhp-trialinstitution.component.css']
})
export class PhBhpTrialinstitutionComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  userData: UserData;
  userSubscription: Subscription;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('convertmodal') convertmodal: TemplateRef<any>;
  @ViewChild('successconvertmodal') successconvertmodal: TemplateRef<any>;
  gridData: InstitutionData[];
  countriesKeyValue: any;
  groupList: InstitutionData[];
  imgItems: boolean = true;
  itemChange: boolean = false;
  addToGroup = {} as InstitutionData;
  searchText: string;
  deleteDataItem;
  concertDataItem;
  horizontalAction = true;
  fields: any[] = [
    // {
    //   'field': 'image', 'title': '', 'width': 50, "ngTemplate": (dataItem) => {
    //     return  `<img src="assets/ph-bhp-institution/svg/Clean Hands.svg">`;
    //   }
    // },
    {
      'field': 'groupName', 'title': 'INSTITUTION_MANAGEMENT.GROUP_2',
      "ngTemplate": (dataItem) => {
        return (dataItem.institution.institution.isGroup) ? dataItem.institution.institution.institutionName : dataItem.institution.groupName;
      }
    },
    {
      'field': 'institutionName', 'title': 'INSTITUTION_MANAGEMENT.INSTITUTIONS',
      // "ngTemplate": (dataItem) => {
      //   return (!dataItem.institution.institution.isGroup) ? dataItem.institution.institution.institutionName : "";
      // }
    },
    { 'field': 'city', 'title': 'USER_MANAGEMENT.LOCATION' },
    {
      'field': 'country', 'title': 'INSTITUTION_MANAGEMENT.COUNTRY',
      // "ngTemplate": (dataItem) => {
      //   const countryName  = this.countriesKeyValue[dataItem.institution.institution.countryID];
      //   const translateCountryName = this.layoutService.translateText(countryName);
      //   return translateCountryName;
      // }
    },
    { 'field': 'email', 'title': 'INSTITUTION_MANAGEMENT.E_MAIL', width: 300 },
    {
      'field': 'trialStartDate', 'title': 'INSTITUTION_MANAGEMENT.START_DATE',
      // "ngTemplate": (dataItem) => {
      //   var data = new Date(dataItem.institution.institution.trialStartDate)
      //   return data.getDate() + '/' + (data.getMonth() + 1) + '/' + data.getFullYear();
      // }
    },
    {
      'field': 'trialEndDate', 'title': 'INSTITUTION_MANAGEMENT.END_DATE',
      // "ngTemplate": (dataItem) => {
      //   var data = new Date(dataItem.institution.institution.trialEndDate)
      //   return data.getDate() + '/' + (data.getMonth() + 1) + '/' + data.getFullYear();
      // }
    },
    { 'field': 'trialExpiryDue', 'title': 'INSTITUTION_MANAGEMENT.EXPIRY_DUE',  },
  ];

  actionItems: any = [
    { name: 'INSTITUTION_MANAGEMENT.EDIT_2', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', onClick: (dataItem) => { this.onChildData('/institution/edit/' + dataItem.institution.institution.institutionID) } },
    { name: 'INSTITUTION_MANAGEMENT.CONVERT', imgSrc: 'assets/ph-bhp-layout/svg/icon-feedback.svg', onClick: (dataItem) => { this.openConvertModal(this.convertmodal, dataItem) } },
    { name: 'INSTITUTION_MANAGEMENT.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) } },
  ];

  pageInfo = {
    items: 'INSTITUTION_MANAGEMENT.TRIAL_INSTITUTIONS',
    itemsPerPageLabel: 'INSTITUTION_MANAGEMENT.TRIAL_INSTITUTIONS_PER_PAGE'
  };
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private router: Router,
    public config: AppConfig,
    private modalService: BsModalService,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    public layoutService: PHBHPLayoutPackageService
    ) { }

  ngOnInit() {
    this.service.getCountriesKeyValuePair().subscribe((res: any) => {
      this.countriesKeyValue = res;
    });
    if (this.config.userData) {
      this.userData = this.config.userData;
      this.OnUserChanges();
    }

    this.userSubscription  = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.OnUserChanges();
    });

    this.layoutService.lang.subscribe(() => {
      // this.userData = this.config.userData;
      // this.OnUserChanges();
    });
  }

  ngOnDestroy(){
    if(this.userSubscription)
      this.userSubscription.unsubscribe();
  }
  delete() {
    this.service.deleteInstitutionById(this.deleteDataItem.institution.institution.institutionID).subscribe(((res: InstitutionData) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = [];
      var index = data.findIndex(institution => institution.institution.institution.institutionID === this.deleteDataItem.institution.institution.institutionID);
      data.splice(index, 1);
      let that = this;
      this.gridData = data.map(item => this.manageGrid(item, that));
    }));
  }

  convertToReal(){
    this.layoutService.showLoader = true;
    this.service.convertTrialInstitution(this.concertDataItem.institution.institution).subscribe(((res: InstitutionData) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = [];
      // remove from trials list
      var index = data.findIndex(institution => institution.institution.institution.institutionID === this.concertDataItem.institution.institution.institutionID);
      data.splice(index, 1);
      let that = this;
      this.gridData = data.map(item => this.manageGrid(item, that));;
      this.layoutService.showLoader = false;
      this.openSuccessConvertModal();
    }));
  }

  OnUserChanges() {
    if (this.userData && this.userData.roleName && !this.itemChange) {
      this.itemChange = true;
      this.layoutService.showLoader = true;
      this.service.getUsersTrialInstitutions(this.userData).subscribe((res: any) => {
        this.layoutService.showLoader = false;
        res.forEach(element => {
          element.institution.institution.city = this.layoutService.translateText(element.institution.institution.city);
        });
        let that = this;
        this.gridData = res.map(item => this.manageGrid(item, that));;
      });

      /*
        1) Super Admin
        2) Country Admin
        3) Group Admin
        4) Institution Admin
      */
      if (this.userData.roleName.roleId == 1) {
        this.service.GetAllGroups().subscribe((res: [InstitutionData]) => {
          this.groupList = res;
        })
        this.actionItems.splice(5, 1);
      } else if (this.userData.roleName.roleId == 2) {
        this.service.GetGroupsByCountryId(this.userData.roleName.roleId).subscribe((res: [InstitutionData]) => {
          this.groupList = res;
        })
        this.actionItems.splice(5, 1);
        // this.fields.splice(0, 1);
        //  this.fields.splice(7, 1);
      } else if (this.userData.roleName.roleId == 3) {
        this.fields.splice(0, 1);
        this.fields.splice(7, 1);
        this.actionItems.splice(1, 1);
        this.actionItems.splice(4, 1);
      } else if (this.userData.roleName.roleId == 4) {
        this.fields.splice(0, 1);
        this.fields.splice(7, 1);
        this.actionItems.splice(1, 1);
        //this.actionItems.splice(5, 1);
      }
    }
  }

  openModal(template: TemplateRef<any>, dataItem) {
    this.addToGroup.institutionID = dataItem.institution.institution.institutionID
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' })
    );
  }
  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  openConvertModal(convertmodal: TemplateRef<any>, dataItem) {
    this.concertDataItem = dataItem
    this.modalRef = this.modalService.show(convertmodal, Object.assign({}, { class: 'w-420' })
    )
  }
  openSuccessConvertModal() {
    this.modalRef = this.modalService.show(this.successconvertmodal, Object.assign({}, { class: 'w-420' })
    )
  }

  selectGroup(id: number) {
    this.addToGroup.groupID = id;
  }
  openstack(stackmodal: TemplateRef<any>) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(stackmodal,
      Object.assign({}, { class: 'w-420' })
    );
  }

  updateGroupId() {
    this.service.AddInstitutionToGroup(this.addToGroup).subscribe((res) => {
      this.addToGroup = {} as InstitutionData;
      this.modalRef.hide()
    })
  }
  manageInstitution(): void {
    this.onChildData('institution');
  }

  onChildData(emitter){
    this.router.navigate([emitter]);
  }

  searchTextChange() {
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  manageGrid(item, that){

    item.institutionName = (!item.institution.institution.isGroup) ? item.institution.institution.institutionName : "";
    item.groupName = (item.institution.institution.isGroup) ? item.institution.institution.institutionName : "";
    item.city = item.institution.institution.city;

    const countryName  = this.countriesKeyValue[item.institution.institution.countryID];
    const translateCountryName = this.layoutService.translateText(countryName);
    item.country = translateCountryName

    item.email = item.adminUser?.email || '';
    let date =  new Date(item.institution.institution.typeStartDate);
    item.trialStartDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();

    date =  new Date(item.institution.institution.typeEndDate);
    item.trialEndDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    item.trialExpiryDue = item.institution.institution.trialExpiryDue;

    return item;
  }


}
